import { createStore as createStoreVuex, useStore as useStoreVuex } from 'vuex';

import accountNotifications from './modules/account-notifications';
import barcodeScanner from './modules/barcode-scanner';
import cart from './modules/cart';
import category from './modules/category';
import categoryFilters from './modules/category-filters';
import club from './modules/club';
import config from './modules/config';
import contentLandingPages from './modules/content-landing-pages';
import deliveryTerms from './modules/delivery-terms';
import favorites from './modules/favorites';
import features from './modules/features';
import freeShippingNotify from './modules/free-shipping-notify';
import home from './modules/home';
import menu from './modules/menu';
import notifications from './modules/notifications';
import orders from './modules/orders';
import product from './modules/product';
import productGalleries from './modules/product-galleries';
import productGalleryModal from './modules/product-gallery-modal';
import productPromoKits from './modules/product-promo-kits';
import productQuickPick from './modules/product-quick-pick';
import promotions from './modules/promotions';
import publications from './modules/publications';
import questions from './modules/questions';
import quickView from './modules/quickView';
import reviews from './modules/reviews';
import search from './modules/search';
import seo from './modules/seo';
import settings from './modules/settings';
import stores from './modules/stores';
import user from './modules/user';

let store;

// экспортируем функцию-фабрику для создания экземпляров нового стора
export const createStore = () => {
  store = createStoreVuex({
    // важно: состояние в модулях должно быть функцией, чтобы модуль мог инстанцироваться несколько раз
    modules: {
      config,
      user,
      menu,
      category,
      categoryFilters,
      cart,
      deliveryTerms,
      product,
      stores,
      orders,
      notifications,
      productGalleries,
      favorites,
      club,
      publications,
      search,
      seo,
      features,
      questions,
      quickView,
      freeShippingNotify,
      reviews,
      productQuickPick,
      settings,
      home,
      productGalleryModal,
      productPromoKits,
      promotions,
      barcodeScanner,
      accountNotifications,
      contentLandingPages,
    },
    devtools: process.env.NODE_ENV === 'development',
  });

  return store;
};

export const useStore = () => useStoreVuex();

export const key = Symbol('store');
